import {ContentState} from '../../store';

export const initialEmailContentState: ContentState = {
  init: false,
  form: {
    recipients: '',
    cc: '',
    bcc: '',
    subject: '',
    value: '',
    attachments: [],
    smtp_from: '',
    smtp_from_fullname: '',
    integration_id: '',
    merge_pdf_config: {},
    merge_csv_config: {},
    /*
     * Only send email if all attachments are available
     */
    send_with_all_attachments: true,
  },
  tmpForm: null,
  isPreview: false,
}
